<template>
  <a-col class="scheduleList_wrap">
    <div class="calendar_container">
      <img src="../../assets/icons/calendar.svg" alt="">
      <a-date-picker
          size="large"
          :locale="locale"
          format="YYYY-MM-DD"
          suffix-icon=" "
          v-model="searchDate"
          :disabled-date="disabledDate"
          @change="searchScheduleData"/>
    </div>
    <div>
      <p class="list_result_num">共 {{ scheduleData.length }} 筆資料</p>
      <a-list v-show="!scheduleData.length">
        <a-empty description="沒有任何資料"/>
      </a-list>
      <a-list v-show="scheduleData.length" item-layout="horizontal" :split="true" :data-source="sortedScheduleData"
              class="schedule_list_container">
        <a-list-item slot="renderItem" slot-scope="item,index" :id="item.journeyCode"
                     @click="turnToDetailData(item.driverUid, item.journeyCode, item.validCount)">
          <div class="list_serial_num">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="list_content">
            <div class="period_container">
              {{ $moment(item.startTime).format('HH:mm') || '--' }}
              <img src="../../assets/icons/schedule_time_arrow.svg" alt="" class="time_arrow">
              {{ $moment(item.endTime).format('HH:mm') || '--' }}
            </div>
            <div class="position_container">
              <img src="../../assets/icons/start_position_icon.svg" alt="">
              {{ item.startGps.lon || '--' }}, {{ item.startGps.lat || '--' }}
            </div>
            <div class="between_line_container">
              <img src="../../assets/icons/position_between_line.svg" alt="" class="between_line">
            </div>
            <div class="position_container">
              <img src="../../assets/icons/end_position_icon.svg" alt="">
              {{ item.endGps.lon || '--' }}, {{ item.endGps.lat || '--' }}
            </div>
            <div class="total_text_container">
              <div>
                <span>累計里程</span>
                {{ (isTbox) ? item.gpsAccumulatedMileage : (item.accumulatedMileage >= 0) ? item.accumulatedMileage : '--' }} km
              </div>
              <div>
                <span>總計</span>
                {{ getTotalHour(item.startTime, item.endTime) }}{{ getTotalMinutes(item.startTime, item.endTime) }}
              </div>
            </div>
            <div class="valid-point-wrap">
              <span class="point-count">總點位</span>{{item.totalCount}} 個 /&nbsp;<span class="point-count">有效點位</span> {{item.validCount}}個
            </div>
          </div>
        </a-list-item>
      </a-list>
    </div>
  </a-col>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_TW';
import {searchScheduleApi} from '../../api/api';
import {mapActions, mapState} from 'vuex';
import moment from "moment/moment";

export default {
  name: 'IndividualScheduleList',
  data() {
    return {
      locale,
      searchDate: this.$moment(this.tempDate),
      scheduleData: [],
      openedTs: '',
      expiredTs: '',
      isTbox: false,
      msgObj: {
        visible: false,
        title: '讀取錯誤',
        okText: '確認',
        cancelText: '',
        detailText: '',
        msgClass: 'msg_confirm_modal',
      },
    }
  },
  mounted() {
    console.log('temp:', this.$moment(this.tempDate).format('YYYY-MM-DD'));
    this.searchDate = this.$moment(this.tempDate);
    this.searchScheduleData(this.$moment(this.tempDate));
  },
  methods: {
    ...mapActions('todayScheduleList', ['scheduleListAction']),
    ...mapActions('todayScheduleList', ['tempDateAction']),
    turnToDetailData(driverUid, scheduleNo, validCount) {
      if(validCount<1) return;
      const deviceUid = this.$route.query.data || '';
      console.log('deviceUid----', deviceUid)
      this.$router.push({
        name: 'individualDetail',
        query: {
          driverUid,
          data: deviceUid,
          deviceUid,
          encodedDeviceUid: deviceUid,
          journeyCode: scheduleNo,
          startTime: this.$moment(this.searchDate).startOf('d').valueOf(),
          endTime: this.$moment(this.searchDate).valueOf(),
          // drivingDate: this.$moment(this.searchDate).format('YYYYMMDD'),
        },
      });
    },
    async requestScheduleList(params) {
      try {
        const result = await searchScheduleApi(params);

        return new Promise((resolve, reject) => {
          if (result.status === 200) {
            resolve(result.data);
          } else reject(result.status);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getScheduleData(params) {
      try {
        const result = await this.requestScheduleList(params);
        this.scheduleData = result.journeyList;
        this.openedTs = result.openedTs;
        this.expiredTs = result.expiredTs;
        this.isTbox = (result.productName === 'STMB-4000');
      } catch (errorStatus) {
        console.log(errorStatus);
        this.combineErrMsg(errorStatus);
        this.$emit('responseStatus', this.msgObj);
      }
    },
    combineErrMsg(status) {
      switch (status) {
          // 3:設備不存在、4:設備停用
        case 3:
        case 4:
          this.msgObj = {
            ...this.msgObj,
            visible: true,
            title: '裝置不存在',
            okText: '撥打電話',
            cancelText: '否',
            detailText: '查無此裝置資訊，請聯繫客服人員',
            msgClass: 'msg_error_modal',
          };
          break;
        case 5:
          this.msgObj = {
            ...this.msgObj,
            detailText: '設備未開通',
            visible: true,
            msgClass: 'msg_confirm_modal'
          };
          break;
        case 6:
          this.msgObj = {
            ...this.msgObj,
            detailText: '設備過期',
            visible: true,
            msgClass: 'msg_confirm_modal'
          };
          break;
        case 7:
          this.msgObj = {
            ...this.msgObj,
            detailText: '設備已損壞',
            visible: true,
            msgClass: 'msg_confirm_modal'
          };
          break;
        case 8:
          this.msgObj = {
            ...this.msgObj,
            detailText: '查詢錯誤',
            visible: true,
            msgClass: 'msg_confirm_modal'
          };
          break;
        default:
          break;
      }
    },
    searchScheduleData(e) {
      this.tempDateAction(e);
      const params = {
        deviceUid: this.deviceUid,
        encodedDeviceUid: this.deviceUid,
        startTime: this.$moment(this.searchDate).startOf('d').valueOf(),
        endTime: this.$moment(this.searchDate).endOf('d').valueOf(),
        // drivingDate: this.searchDate.format('YYYYMMDD'),
      };

      this.getScheduleData(params);
    },
    getTotalHour(startTime, endTime) {
      const hour = Math.floor(this.$moment(endTime).diff(this.$moment(startTime), 'minutes') / 60);

      if (hour === 0) return '';
      return hour > 10 ? `${hour}時` : `0${hour}時`;
    },
    getTotalMinutes(startTime, endTime) {
      const minutes = this.$moment(endTime).diff(this.$moment(startTime), 'minutes') % 60;

      if (minutes === 0) return '01分';
      return minutes > 10 ? `${minutes}分` : `0${minutes}分`;
    },
    disabledDate(currentDate) {
      // const openedDateStr = this.$moment(this.openedTs).format('YYYY-MM-DD');
      // const expiredDateStr = this.$moment(this.expiredTs).format('YYYY-MM-DD');
      // const currentDateStr = currentDate.format('YYYY-MM-DD')
      // return currentDateStr < openedDateStr || currentDateStr > expiredDateStr || (currentDate && currentDate > moment().endOf('day'));

      return currentDate && currentDate > moment().endOf('day');
    },
  },
  computed: {
    ...mapState('identidyOpenStatus', ['deviceUid']),
    ...mapState('todayScheduleList', ['scheduleList']),
    ...mapState('todayScheduleList', ['tempDate']),
    sortedScheduleData() {
      //    const sortedList = [...this.scheduleData].sort((pre, current) => {
      //         // if (pre.journeyCode < current.journeyCode) return -1;
      //         // else return 1;
      //         return 1;
      //    })
      console.log('sortedList', [...this.scheduleData]);
      return [...this.scheduleData];
    }
  },
}
</script>

<style lang="scss" scoped>
.scheduleList_wrap {
  top: 54px;
}

.calendar_container {
  position: relative;
  padding: 0 12px;

  img {
    position: absolute;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
}

.list_result_num {
  padding: 8px 12px;
  text-align: right;
  line-height: 24px;
  color: rgba(52, 55, 65, 0.6);
  margin: 0;
}

.schedule_list_container {
  padding: 0 12px;

  .ant-list-item {
    justify-content: flex-start;
    padding: 14px 0;
    align-items: stretch;

    &:first-child {
      padding-top: 0;
    }

    .list_serial_num {
      flex-basis: 12%;

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(52, 55, 65, 0.6);
        border-radius: 50%;
        color: #FFFF;
        width: 1.5rem;
        height: 1.5rem;
        font-weight: 900;
        margin-left: 2px;
      }
    }

    .list_content {
      flex-basis: 88%;

      > div {
        margin-bottom: 3px;
        line-height: 24px;
        color: #343741;

        &:nth-child(2) {
          margin-bottom: 4px;
        }

        span {
          color: rgba(52, 55, 65, 0.6);
          font-size: 12px;
        }

        .time_arrow {
          margin: 0 8px 3px 8px;
        }

        img {
          margin: 0 5px 3px 0;
        }
      }

      .total_text_container {
        display: flex;

        div {
          &:first-child {
            flex-basis: 50%;
          }

          &:last-child {
            flex-basis: 50%;
          }
        }
      }

      .period_container {
        margin-left: 2px;
      }

      .between_line_container {
        padding: 0;
        position: relative;
        height: 2px;

        img {
          position: absolute;
          top: -10px;
          left: 2px;
        }
      }

      .position_container {
        display: flex;
      }
    }
    .valid-point-wrap{
      display: flex;
      align-items: center;
      font-size: 8px!important;
      .point-count{
        padding: 0px 3px;
        border-radius: 8px;
        border: 1px solid #b6e643;
        background-color: #b6e643;
        margin-right: 5px;
        color: #4b5745!important;
      }
    }

  }
}
</style>
